<template>
<div class="app has-header">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView"></menutabs>
    </div>
    <component :is="tabSelected.view"/>
</div>
</template>

<script>
import employeepayrollaccounting from './EmployeePayrollAccounting.vue'
import employeeworkbalanceoverview from './EmployeeWorkBalanceOverview.vue'
import accountingperiodsettings from './AccountingPeriodSettings.vue'
import bonuspaymentsettings from './BonusPaymentSettings.vue'
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        employeepayrollaccounting,
        employeeworkbalanceoverview,
        accountingperiodsettings,
        bonuspaymentsettings
    },
    name: 'WorkBalanceMain',
    data() {
        return {
            viewMode: 1, 
            loading: true,
            defaultView: 'employeepayrollaccounting',
            tabSelected: null,
        }
    },
    watch: {},
    props: {
        view: String,
    },
    created() {

        let view = this;
        if(this.$router.currentRoute.params.tab){
            let tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab){
                this.tabSelected = tab;
            }
        } else {
            let tab = this.tabs.find(t => t.selected);
            if(tab) this.tabSelected = tab;
            else this.tabSelected = {view: this.view ? this.view : this.defaultView};
        }
    },
    mounted(){

    },
    computed: {
        ...mapGetters(['storeId','storeSettings', 'isSuperUser']),
        tabs(){
            let tabs = [
                {label: this.$t('global.menubar.workbalance'), view: 'employeepayrollaccounting', selected: true},
                {label: this.$t('workBalance.extraPay.title'), view: 'employeeextrapaymentoverview', selected: false},
                {label: this.$t('workBalance.balances.title'), view: 'employeeworkbalanceoverview', selected: false},
                {label: this.$t('workBalance.accounting.title'), view: 'accountingperiodsettings', selected: false},
                {label: this.$t('workBalance.bonus.title'), view: 'bonuspaymentsettings', selected: false}
            ]
            
            if(this.storeSettings && this.storeSettings.simpleMode){
                tabs.splice(2, 1) //removes employeeworkbalanceoverview
            }

            if(this.storeSettings && this.storeSettings.useAvgWorkTimeForPrefs === true && !this.storeSettings.simpleMode){
                tabs.splice(1, 0, {label: this.$t('workBalance.averages.title'), view: 'employeeaverageworktimeoverview', selected: false})
                
            }

            return tabs;
        }
    },
    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
        }
    }
}
</script>
